<template>
  <div class="promo-grid">
    <!-- Main Big Promo -->
    <div class="promo-item main-promo" @click="$router.push('/productDetail?productId=' + mainPromo.id)">
      <div class="promo-header">
        <span class="badge">Hot Deals</span>
        <h3 class="title">{{ mainPromo.storeName || '100 Billion Subsidy' }}</h3>
        <p class="subtitle">{{ mainPromo.storeInfo || 'Limited time offer' }}</p>
      </div>
      <div class="promo-content">
        <img :src="mainPromo.image || 'https://img.alicdn.com/imgextra/i4/O1CN016vU7vL1P4mQ9XkQXL_!!6000000001786-2-tps-240-240.png'" alt="promo" />
      </div>
    </div>

    <!-- Secondary Promos Grid -->
    <div class="secondary-promos">
      <div class="promo-item sub-promo" v-for="(item, index) in subPromos" :key="index" :style="{ backgroundColor: item.bgColor }" @click="$router.push('/productDetail?productId=' + item.id)">
        <div class="promo-info">
          <span class="label" :style="{ color: item.labelColor }">{{ item.label }}</span>
          <p class="name">{{ item.name }}</p>
          <div class="price-tag" v-if="item.price">
             <span class="currency">￥</span>
             <span class="value">{{ item.price }}</span>
          </div>
        </div>
        <img :src="item.image" :alt="item.name" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PromoGrid',
  props: {
    promoData: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    mainPromo() {
      return this.promoData[0] || {}
    },
    subPromos() {
       // Fill with placeholders if data is insufficient but prioritize real data
       const realOnes = this.promoData.slice(1, 4).map((item, index) => ({
         name: item.storeName,
         id: item.id,
         label: 'Hot Deals',
         price: item.price,
         image: item.image,
         bgColor: ['#f6faff', '#fff7f0', '#fff1f0'][index] || '#f8f9fa',
         labelColor: ['#1890ff', '#fa8c16', '#f5222d'][index] || '#999'
       }))
       return realOnes
    }
  }
}
</script>

<style lang="scss" scoped>
.promo-grid {
  display: flex;
  gap: 16px;
  width: 100%;

  .promo-item {
    border-radius: 16px;
    padding: 16px;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    &:hover {
      transform: translateY(-4px);
      box-shadow: 0 10px 20px rgba(0,0,0,0.08);
    }
  }

  .main-promo {
    flex: 1.5;
    background: linear-gradient(135deg, #ff4e50 0%, #f9d423 100%);
    color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 200px;

    .promo-header {
      .badge {
        background: rgba(255,255,255,0.2);
        padding: 4px 10px;
        border-radius: 20px;
        font-size: 12px;
        backdrop-filter: blur(4px);
      }
      .title {
        font-size: 24px;
        font-weight: 800;
        margin-top: 12px;
      }
      .subtitle {
        font-size: 14px;
        opacity: 0.9;
      }
    }
    .promo-content {
      align-self: flex-end;
      img {
        width: 100px;
        height: 100px;
        object-fit: contain;
      }
    }
  }

  .secondary-promos {
    flex: 2;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 12px;

    .sub-promo {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 100%;
      
      .promo-info {
        .label {
          font-size: 11px;
          font-weight: 700;
        }
        .name {
          font-size: 14px;
          font-weight: 600;
          color: #333;
          margin: 4px 0;
        }
        .price-tag {
          .currency { font-size: 10px; font-weight: 600; color: #ff4d4f; }
          .value { font-size: 16px; font-weight: 700; color: #ff4d4f; }
        }
      }
      img {
        width: 70px;
        height: 70px;
        align-self: flex-end;
        object-fit: contain;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/PageIndex/indexAll/components/PromoGrid.vue